'use strict';
import * as _ from 'lodash';
import {EnterYearDialogModel} from './enterYearDialogModel.js'

const familyBreastCancerTitle = "FAMILY HISTORY OF BREAST CANCER";
const personalBreastCancerTitle = "PERSONAL HISTORY OF BREAST CANCER";

export class RightHistoryRecordDetailDialogModel {
  constructor(config, data, editMode, title, patDOB, dynamicLabels, $rootScope) {
    this.dynamicLabels = dynamicLabels;
    this.editMode = editMode;
    this.config = config;
    this.resultData = data;
    this.data = _.cloneDeep(data);
    this.dataCopy = _.cloneDeep(data);
    this.title = title.toUpperCase();
    this.modalService = null;
    this.scope = null;
    this.fdateActivated = this.data.FDate === '' || this.data.FDate === '/  /';
    this.ldateActivated = this.data.LDate === '' || this.data.LDate === '/  /';
    this.dateActivated = this.data.Date === '' || this.data.Date === '/  /';
    this.disabledSide = false;
    this.hideOthers = true;
    this.patDOB = patDOB;
    this.selectedRelativeParentsList = [];
    this.techpadSettings = $rootScope.techpadSettings;

    // TPAD-1092: Norton - Techpad BRCA1 and BRCA2 support
    this.hasBRCA1 = false;
    this.hasBRCA2 = false;

    this.familyBRCA1Value = null;
    this.familyBRCA2Value = null;

    this.newDiagnosisYearConfig = null;
    this.newYearConfig = null;
    this.newFYearConfig = null;
    this.newLYearConfig = null;
  }

  init(modal, scope, modalService, ionicDatePicker) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
    this.ionicDatePicker = ionicDatePicker;
    if (this.data.FDate && this.data.FDate !== '/  /') {
      let dateParts = this.data.FDate.split('/');
      this.data.FMonth = parseInt(dateParts[0]).toString();
      this.data.FDay = dateParts[1];
      this.data.FYear = dateParts[2];
      this.data.FDate = '';
    }
    if (this.data.LDate && this.data.LDate !== '/  /') {
      let dateParts = this.data.LDate.split('/');
      this.data.LMonth = parseInt(dateParts[0]).toString();
      this.data.LDay = dateParts[1];
      this.data.LYear = dateParts[2];
      this.data.LDate = '';
    }
    if (this.data.List) {
      this.checkIfSideDisabled(this.data.List);
      this.checkIfListExists();
    } else if (this.data.Type) {
      this.checkIfSideDisabled(this.data.Type);
      this.checkIfTypeExists();
    }
    if (this.data.Relative) {
      this.checkIfRelativeExists();
    }
    if (this.config.Status) {
      this.initFamilyBRCAValues();
    }
    if (this.config.Cancer && this.data.DiagnosisYear && !this.config.DYear.Options.some(option => option.Code === this.data.DiagnosisYear)) {
      this.newDiagnosisYearConfig = { Code: this.data.DiagnosisYear, Desc: this.data.DiagnosisYear };
      this.config.DYear.Options.push(this.newDiagnosisYearConfig);
    }
    if (this.config.Porcedure && !this.config.Procedure) {
      this.config.Procedure = this.config.Porcedure;
    }
    if (this.config.Procedure && this.data.Year && !this.config.Year.Options.some(option => option.Code === this.data.Year)) {
      this.newYearConfig = { Code: this.data.Year, Desc: this.data.Year };
      this.config.Year.Options.push(this.newYearConfig);
    }
    if (this.config.HORM && this.data.FYear && !this.config.FYear.Options.some(option => option.Code === this.data.FYear)) {
      this.newFYearConfig = { Code: this.data.FYear, Desc: this.data.FYear };
      this.config.FYear.Options.push(this.newFYearConfig);
    }
    if (this.config.HORM && this.data.LYear && !this.config.LYear.Options.some(option => option.Code === this.data.LYear)) {
      this.newLYearConfig = { Code: this.data.LYear, Desc: this.data.LYear };
      this.config.LYear.Options.push(this.newLYearConfig);
    }

    if (familyBreastCancerTitle === this.title && this.techpadSettings.PBCXDef){
      this.data.Type = this.techpadSettings.PBCXDef;
    }
    else if(personalBreastCancerTitle === this.title && this.techpadSettings.FBCXDef){
      this.data.Type = this.techpadSettings.FBCXDef;
    }
  }

  checkIfSideDisabled(type) {
    let shouldDisableSide = false;
    let defaultSide = '';
    let list = this.config.Procedure || this.config.Porcedure || this.config.Cancer || this.config.HORM;
    list.Options.forEach((option) => {
      if (option.Code === type && option.Side && option.Side === "Disable") {
        shouldDisableSide = true;
        defaultSide = option.DefaultSide || option.DefalutSide;
      }
    });
    this.disabledSide = shouldDisableSide;
    if (this.disabledSide) {
      this.data.Side = defaultSide;
    }
  }

  checkIfListExists() {
    let isListExists = false;
    let list = this.config.Procedure || this.config.Porcedure;
    list.Options.forEach((option) => {
      if (option.Code === this.data.List) {
        isListExists = true;
      }
    });
    if (!isListExists) {
      this.data.List = null;
    }
  }

  checkIfTypeExists() {
    let isTypeExists = false;
    let list = this.config.Cancer || this.config.HORM;
    list.Options.forEach((option) => {
      if (option.Code === this.data.Type) {
        isTypeExists = true;
      }
    });
    if (!isTypeExists) {
      this.data.Type = null;
    }
  }

  checkIfAskParentRelative() {
    if (!this.data.Relative) {
      return false;
    }
    let list = this.config.Relative;
    const selectedRelativeConfiguration = list.Options.find((option) => option.Code === this.data.Relative);
    const askParent = selectedRelativeConfiguration.AskParent === true.toString();
    this.selectedRelativeParentsList = askParent && selectedRelativeConfiguration.ParentsList;
    return askParent;
  }

  checkIfRelativeExists() {
    let isRelativeExists = false;
    let list = this.config.Relative;
    list.Options.forEach((option) => {
      if (option.Code === this.data.Relative) {
        isRelativeExists = true;
      }
    });
    if (!isRelativeExists) {
      this.data.Relative = null;
    }
  }

  _hasChanged() {
    return !_.isEqual(this.dataCopy, this.data);
  }

  toggleFDateActivated() {
    this.fdateActivated = true;
    this.data.FDate = '';
  }

  toggleLDateActivated() {
    this.ldateActivated = true;
    this.data.LDate = '';
  }

  toggleDateActivated() {
    this.dateActivated = true;
    this.data.Date = '';
  }

  getDateString(date) {
    let day = date.getDate().toString();
    let month = (date.getMonth() + 1).toString();
    let year = date.getFullYear().toString();
    return month + '/' + day + '/' + year;
  }

  isYearNotPicked(year) {
    return year && (year == '-1' || year == '-2')
  }

  isMoreThan10Year(year) {
    return year && year == '>10';
  }

  validateAgeCorrespondsToDate(patDOB, date, age) {
    if (!((date && date != '//') && age)) {
      return true;
    }
    let splittedDateArray = date.split('/');
    let DateYearDateValidation = splittedDateArray[2];
    let patYearDateValidation = new Date(patDOB).getFullYear();
    let patTrueAgeDateValidation = parseInt(DateYearDateValidation) - patYearDateValidation;
    if (patTrueAgeDateValidation != parseInt(age)) {
      this.modalService.showAlert(`Date does not match entered age`);
      return false;
    }
    return true;
  }

  validateAgeCorrespondsToYear(patDOB, Age, DiagnosisYear, modalMessage) {
    if (!(DiagnosisYear && Age && !this.isYearNotPicked(DiagnosisYear))) {
      return true;
    }
    let isDiagYearMoreThan10Years = this.isMoreThan10Year(DiagnosisYear);
    let shouldShowErrorModalDiagnosis = false;
    let patYearAgeYearValidationDiagnosis = new Date(patDOB).getFullYear();
    if (isDiagYearMoreThan10Years) {
      let currentYearDiagnosis = new Date().getFullYear();
      let PatientAge10YearsAgoDiagnosis = currentYearDiagnosis - patYearAgeYearValidationDiagnosis - 10;
      shouldShowErrorModalDiagnosis = Age > PatientAge10YearsAgoDiagnosis;
    } else {
      let patTrueAgeYearValidationDiagnosis = parseInt(DiagnosisYear) - patYearAgeYearValidationDiagnosis;
      shouldShowErrorModalDiagnosis = patTrueAgeYearValidationDiagnosis != parseInt(Age)
    }
    if (shouldShowErrorModalDiagnosis) {
      this.modalService.showAlert(modalMessage ? modalMessage : `Year and month do not match entered age`); //`Year and month do not match entered age`);
      return false;
    }
    return true;
  }

  validateDateCorrespondsYear(date, DiagnosisYear, DiagnosisMonth) {
    if (!((date && date != '//') && DiagnosisYear && DiagnosisMonth && !this.isMoreThan10Year(DiagnosisYear))) {
      return true;
    }
    let splittedDateYearDiagnosisValidation = date.split('/');
    let DateYearYearDiagnosisValidation = parseInt(splittedDateYearDiagnosisValidation[2]);
    let DateMonthYearDiagnosisValidation = parseInt(splittedDateYearDiagnosisValidation[0]);
    if (DateYearYearDiagnosisValidation != DiagnosisYear || DateMonthYearDiagnosisValidation != DiagnosisMonth) {
      this.modalService.showAlert(`Year and month do not match entered date`);
      return false;
    }
    return true;
  }

  isMonthDayAndYearNotFilled(Year, Month, Day) {
    return !(!Year && !Month && !Day) && (!Year || !Month || !Day);
  }

  handleEmptyDateFields(Year, Month, Day, validateFieldName) {
    let missingFields = [
      !Month ? "month" : "",
      !Day ? "day" : "",
      !Year ? "year" : "",
    ];
    missingFields = missingFields.filter((item) => !!item);
    this.modalService.showAlert(
      `${validateFieldName} date not complete. Please fill out the ${missingFields.join(
        ", "
      )} or leave it empty.`
    );
  }

  validateMonthDayAndYearFieldsNotEmpty(Year, Month, Day, validateFieldName) {
    if (Day && (!Year || !Month)) {
      this.modalService.showAlert("You must select a year and month if you select a day.");
      return false;
    }
    if (Month && !Year) {
      this.modalService.showAlert("You must select a year if you select a month.");
      return false;
    }
    if (!Year) {
      this.modalService.showAlert("You must select a year");
      return false;
    }
    if (Year && !Month && !Day) {
      return true;
    }
    if (this.isMonthDayAndYearNotFilled(Year, Month, Day)) {
      if (Month && Year) {
        return true;
      }
      this.handleEmptyDateFields(Year, Month, Day, validateFieldName);
      return false;
    }
    return true;
  }

  ValidateLastDateLaterThanFirstDate(FYear, FMonth, FDay, LYear, LMonth, LDay) {

    FMonth = FMonth || 12;
    LMonth = LMonth || 12;

    FDay = FDay || new Date(FYear, FMonth, 0).getDate();
    LDay = LDay || new Date(LYear, LMonth, 0).getDate();

    const firstUseDate = new Date(`${FMonth}/${FDay}/${FYear}`);
    const lastUseDate = new Date(`${LMonth}/${LDay}/${LYear}`);
    if (lastUseDate < firstUseDate) {
      this.modalService.showAlert(
        `Last use date cannot be before first use date`
      );
      return false;
    }
    return true;
  }

  validateLastAgeLaterThanFirstAge(FAge, LAge) {
    if (!(FAge && LAge)) {
      return true;
    }
    const fAge = parseInt(FAge);
    const lAge = parseInt(LAge);
    if (lAge < fAge) {
      this.modalService.showAlert(`Last use age can't be before first use age`);
      return false;
    }
    return true;
  }

  validateHormoneData() {
    return (
      this.validateMonthDayAndYearFieldsNotEmpty(this.data.FYear, this.data.FMonth, this.data.FDay, "First Use") 
      && this.validateMonthDayAndYearFieldsNotEmpty( this.data.LYear, this.data.LMonth, this.data.LDay, "Last Use") 
      && this.ValidateLastDateLaterThanFirstDate( this.data.FYear, this.data.FMonth, this.data.FDay, this.data.LYear, this.data.LMonth, this.data.LDay)
      && this.validateLastAgeLaterThanFirstAge(this.data.FAge, this.data.LAge) 
      && this.validateAgeCorrespondsToYear( this.patDOB, this.data.FAge, this.data.FYear, `First use date does not match entered age`) 
      && this.validateAgeCorrespondsToYear( this.patDOB, this.data.LAge, this.data.LYear, `Last use date does not match entered age`)
    );
  }

  validateDate() {
    const isValidateRelativeWithPatientDOB = !this.data.Relative;
    if (isValidateRelativeWithPatientDOB) {
      if (!this.validateAgeCorrespondsToDate(this.patDOB, this.data.Date, this.data.Age) ||
        !this.validateAgeCorrespondsToYear(this.patDOB, this.data.Age, this.data.DiagnosisYear)) {
        return false;
      }
    }
    return this.validateDateCorrespondsYear(this.data.Date, this.data.DiagnosisYear, this.data.DiagnosisMonth) &&
      this.validateAgeCorrespondsToYear(this.patDOB, this.data.Age, this.data.Year) &&
      this.validateDateCorrespondsYear(this.data.Date, this.data.Year, this.data.Month);
  }

  validateCancerOrBRCADataForRelatives() {
    const relativeConfig = this.config.Relative.Options.find(relative => relative.Code === this.data.Relative);
    if (relativeConfig.AskParent === true.toString() && !this.data.Parent) {
      this.modalService.showAlert(`You must specify a parent`);
      return false;
    } else if (relativeConfig.AskParent !== true.toString() && this.data.Parent) {
      this.data.Parent = '';
    }
    return true;
  }

  validateAnswer() {
    if (!this.validateType() 
        || !this.validateRelative() 
        || !this.validateBRCAResult() 
        || !this.validateResultField()) {
        return false;
    }
    if (!this.validateDate()) {
      return false;
    }
    if (this.config.HORM) {
      return this.validateHormoneData();
    }
    if (this.config.Relative && (this.config.Cancer || this.config._editorType.Id === "BRCA")) {
      return this.validateCancerOrBRCADataForRelatives();
    }
    return true;
  }

  validateType() {
    if ((this.config.Cancer || this.config.HORM || this.config.Procedure || this.config.Porcedure) && !this.data.Type && !this.data.List) {
      this.modalService.showAlert("You must specify a type");
      return false;
    }
    return true;
  }
  validateRelative() {
    if (this.config.Relative && !this.data.Relative) {
      this.modalService.showAlert("You must specify a relative");
      return false;
    }
    return true;
  }
  validateBRCAResult() {
    if (this.config.Status && (!this.data.Brca1 || !this.data.Brca2)) {
      this.modalService.showAlert("You must select a BRCA result");
      return false;
    }
    return true;
  }

  validateResultField(){
    if (this.config.IsValidateHistoryResultField 
        && this.config.Procedure 
        && this.config._editorType.Id === "BS" 
        && !this.data.Result) {
      this.modalService.showAlert("You must specify a result");
      return false;
    }
    return true;
  }

  save() {
    if (!this.validateAnswer()) {
      return;
    }

    this.clearConfigIfNeeded();
    if (this.data.FDate instanceof Date) {
      this.data.FDate = this.getDateString(this.data.FDate);
    } else if (this.data.FDate && this.data.FDate !== '/  /') {
      this.data.FDate = this.data.FMonth + '/' + this.data.FDay + '/' + this.data.FYear;
    }
    if (this.data.LDate instanceof Date) {
      this.data.LDate = this.getDateString(this.data.LDate);
    } else if (this.data.LDate && this.data.LDate !== '/  /') {
      this.data.LDate = this.data.LMonth + '/' + this.data.LDay + '/' + this.data.LYear;
    }
    if (this.data.Date instanceof Date) {
      this.data.Date = this.getDateString(this.data.Date);
    }
    _.assign(this.resultData, this.data);
    this.modalInstance.remove();
  }

  async delete() {
    const confirmed = await this.modalService.showConfirmation(null, 'Are you sure you want to delete this record?');
    if (confirmed) {
      this.deleted = true;
      this.modalInstance.remove();
    }
  }

  getDisplayValue(selectedValue, optionsConfig) {

  }

  async closeWindow() {
    if (this._hasChanged()) {
      const confirmed = await this.modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?');
      if (confirmed) {
        this.clearConfigIfNeeded();
        this.cancelled = true;
        this.modalInstance.remove();
      }
      return;
    }
    this.clearConfigIfNeeded();
    this.cancelled = true;
    this.modalInstance.remove();
  }

  clearConfigIfNeeded(){
    if(this.newDiagnosisYearConfig){
      this.config.DYear.Options = this.config.DYear.Options.filter(option => option.Code !== this.newDiagnosisYearConfig.Code);
    }
    if(this.newYearConfig){
      this.config.Year.Options = this.config.Year.Options.filter(option => option.Code !== this.newYearConfig.Code);
    }
    if(this.newFYearConfig){
      this.config.FYear.Options = this.config.FYear.Options.filter(option => option.Code !== this.newFYearConfig.Code);
    }
    if(this.newLYearConfig){
      this.config.LYear.Options = this.config.LYear.Options.filter(option => option.Code !== this.newLYearConfig.Code);
    }
  }

  /*close() {
    this.cancelled = true;
    this.modalInstance.remove();
  }*/

  changeDate(data, field) {
    let val = data[field];

    let minDate = new Date(1900, 1, 1);
    let maxDate = new Date(new Date().getFullYear(), 11, 31);

    let ipObj = {
      callback: function (val) {
        let date = new Date(val);
        if (date > maxDate) {
          date = maxDate;
        }
        else if (date < minDate) {
          date = minDate;
        }
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let year = date.getFullYear();
        data[field] = month + '/' + day + '/' + year;
      },
      inputDate: !val || val === '/  /' || val === '//' ? new Date() : new Date(val),
      from: minDate,
      to: maxDate
    };

    this.ionicDatePicker.openDatePicker(ipObj);
  }

  // TPAD-1092: Norton - Techpad BRCA1 and BRCA2 support
  initFamilyBRCAValues() {
    this.familyBRCA1Value = this.data.Brca1;
    this.hasBRCA1 = this.data.Brca1 === '1' || this.data.Brca1 === '2';
    this.familyBRCA2Value = this.data.Brca2;
    this.hasBRCA2 = this.data.Brca2 === '1' || this.data.Brca2 === '2';
  }

  setFamilyBRCAValue() {
    this.data.Brca1 = this.familyBRCA1Value;
    this.data.Brca2 = this.familyBRCA2Value;
  }

  familyBRCA1Change(value) {
    this.familyBRCA1Value = value;
    if (value == 0) {
      this.hasBRCA1 = false;
      if (angular.element(document).find('input[data-id=FamilyBRCA1No]').prop("checked") === false) {
        this.familyBRCA1Value = '';
      }
    }
    this.setFamilyBRCAValue();
  }

  familyBRCA2Change(value) {
    this.familyBRCA2Value = value;
    if (value == 0) {
      this.hasBRCA2 = false;
      if (angular.element(document).find('input[data-id=FamilyBRCA2No]').prop("checked") === false) {
        this.familyBRCA2Value = '';
      }
    }
    this.setFamilyBRCAValue();
  }

  async onYearSelectedChanged(year, yearConfig, yearResult){
    const otherYear = "-2";
    if (year && year === otherYear){
      const result = await this.modalService.showEnterYearPromptAsync(new EnterYearDialogModel({to:this.config[yearConfig].Options[0].Code}));
      if (result){
        if (!this.config[yearConfig].Options.some(x => x.Code === "" + result)){
          this.config[yearConfig].Options.push({Code: "" + result, Desc: result});
        }
        this.data[yearResult] = "" + result;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/rightHistoryRecordDetail.js